export const getWebsiteUrl = () => {
  if (process.env.NODE_ENV !== "production")
    // we are using this because stripe requires a https url and does not accept localhost
    return "https://butikdanmark-fe-staging.osc-fr1.scalingo.io";

  return typeof window !== "undefined" && window.location.origin
    ? window.location.origin
    : "";
};
